import React from "react";
import { toast } from "react-toastify";

import { ServiceAccountEditContent } from "./service-account-edit-content";
import { ServiceAccountStaticContent } from "./service-account-static-content";

import type { ServiceAccount } from "../../../../../../application/domain/service-account/service-account";

type ServiceAccountUpdateParam = Pick<
  ServiceAccount,
  "description" | "roles" | "groupsRoles"
>;

type Props = {
  serviceAccount: ServiceAccount;
  groups: { id: string; name: string }[];
  onClickUpdateServiceAccount: (
    param: ServiceAccountUpdateParam,
    callback: {
      onSucceeded: (updated: ServiceAccount) => void;
      onFailed: (errorMessage: string) => void;
    },
  ) => void;
  onClickDisableServiceAccount?: (
    param: { serviceAccountId: ServiceAccount["id"] },
    callback: {
      onSucceeded: () => void;
      onFailed: (errorMessage: string) => void;
    },
  ) => void;
};

export const BasicInfo: React.FC<Props> = ({
  serviceAccount,
  groups,
  onClickUpdateServiceAccount,
  onClickDisableServiceAccount,
}) => {
  const [viewState, setViewState] = React.useState<"show" | "edit">("show");

  const [formDisabled, setFormDisabled] = React.useState<boolean>(false);

  return (
    <>
      {viewState === "show" && (
        <ServiceAccountStaticContent
          serviceAccount={serviceAccount}
          groups={groups}
          onClickStartEdit={() => {
            setViewState("edit");
          }}
          onClickDisableServiceAccount={onClickDisableServiceAccount}
        />
      )}
      {viewState === "edit" && (
        <ServiceAccountEditContent
          serviceAccount={serviceAccount}
          onClickCancel={() => {
            setViewState("show");
          }}
          onClickUpdate={(param) => {
            setFormDisabled(true);
            onClickUpdateServiceAccount(param, {
              onSucceeded: () => {
                toast.success("更新しました。");
                setFormDisabled(false);
                setViewState("show");
              },
              onFailed: (message) => {
                toast.error(message);
                setFormDisabled(false);
              },
            });
          }}
          disabled={formDisabled}
        />
      )}
    </>
  );
};
